import { Box, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import type Allowance from 'modules/timeoff/store/models/Allowance'

interface Props {
  amount: number
  allowance: Allowance
}

const DaysPerPolicy = ({ amount, allowance }: Props) => {
  const accrueTitle = i18n.t('time_off.accrued_tooltip.hours_accrued')

  const fixedBalanceTitle = allowance.isDays
    ? i18n.t('time_off.accrued_tooltip.days_per_policy')
    : i18n.t('time_off.accrued_tooltip.hours_per_policy')

  const title = !allowance.isTimeWorked ? fixedBalanceTitle : accrueTitle

  let workingTitle

  if (allowance.isDays) {
    switch (allowance.attributes.days_type) {
      case 'working_days':
        workingTitle = i18n.t('time_off.accrued_tooltip.working_days')
        break
      case 'natural_days':
        workingTitle = i18n.t('time_off.accrued_tooltip.natural_days')
        break
      case 'french_calendar_days':
        workingTitle = i18n.t('time_off.accrued_tooltip.french_calendar_days')
        break
      case 'french_ouvres':
        workingTitle = i18n.t('time_off.accrued_tooltip.french_ouvres')
        break
      default:
        workingTitle = i18n.t('time_off.accrued_tooltip.working_days')
        break
    }
  } else {
    workingTitle = allowance.workingDays
      ? i18n.t('time_off.accrued_tooltip.working_hours')
      : i18n.t('time_off.accrued_tooltip.natural_hours')
  }

  return (
    <Box>
      <Box flexDirection="row" justifyContent="spaceBetween">
        <Text.Normal capitalize color="grey000White">
          {title}
        </Text.Normal>
        <Text.Normal color="grey000White">{i18n.formatNumber(amount)}</Text.Normal>
      </Box>
      {!allowance.isTimeWorked && (
        <Box flexDirection="row" justifyContent="flexStart">
          <Text.Normal size="200" color="grey000White">
            {workingTitle}
          </Text.Normal>
        </Box>
      )}
    </Box>
  )
}

export default observer(DaysPerPolicy)
